module.exports = __webpack_public_path__ + "img/classic.b325de54.jpg";